import React from 'react';
//import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
//import QuoteOfTheDay from '../components/QuoteOfTheDay'; // 👈 import

//import DashboardGrid from '../components/DashboardGrid';
import DashboardGridReadOnly from '../components/DashboardGridReadOnly';
import widgetRegistry from '../widgets/registry';



const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const name = user.user?.name || '';
  const initials = `${name.charAt(0)}`.toUpperCase();

  const layout = [];

  return (
    <div className="min-h-screen surface-ground p-4">
      <div className="flex justify-content-between align-items-center mb-4">
        <h2 className="m-0">Dashboard</h2>
        <Button
          label="Settings"
          icon="pi pi-cog"
          severity="secondary"
          
          onClick={() => navigate('/settings')}
        />
        <Button
          label="Log Out"
          icon="pi pi-sign-out"
          severity="secondary"
          outlined
          onClick={handleLogout}
        />
      </div>

      
        <div className="flex align-items-center gap-3">
          <Avatar label={initials || 'U'} size="xlarge" shape="circle" />
          <div>
            <h3 className="m-0">
              Welcome, {name}!
            </h3>
            
          </div>
        </div>
      
      
    <DashboardGridReadOnly fallbackLayout={layout} widgetRegistry={widgetRegistry} />
      
    </div>
  );
};

export default Dashboard;
